import Vue from 'vue'
import _ from 'lodash'

export default {
    addRoomDoc: function(state, roomDocList){
        if(!roomDocList) return;

        const addDocFile = (roomDocFile) => {
            let prev = this.getters['doc/getRoomDocFile'](roomDocFile);
            if(prev){
                _.merge(prev, roomDocFile);
            }else{
                let roomDoc = this.getters['doc/getRoomDoc'](roomDocFile.roomGroupId);
                roomDoc.roomDocFiles.push(roomDocFile);
            }
        }

        const addDoc = (roomDoc) => {
            if(!roomDoc.roomGroupId) return;
            let prev = this.getters['doc/getRoomDoc'](roomDoc.roomGroupId)
            let roomDocFiles = _.cloneDeep(roomDoc.roomDocFiles)
            if(prev) {
                delete roomDoc.roomDocFiles
                // _.merge(prev, roomDoc)
                Object.keys(roomDoc)
                    .forEach((key) => {
                       if(prev[key] === undefined) {
                           Vue.set(prev, key, roomDoc[key])
                       } else {
                           prev[key] = roomDoc[key]
                       }
                    })
                if(!prev.roomDocFiles) prev.roomDocFiles = [];
            } else {
                let roomGroup = this.getters['roomGroup/getRoomGroup'](roomDoc.roomGroupId)
                if(!roomGroup) return;
                Vue.set(roomGroup, 'roomDoc', roomDoc)
            }

            roomDocFiles && roomDocFiles.forEach(addDocFile)
        }
        if(Array.isArray(roomDocList)) {
            roomDocList.forEach(addDoc)
        } else {
            addDoc(roomDocList)
        }

    },
    addRoomDocFile: function(state, data){
        let {roomDocFile} = data;
        const addDocFile = (roomDocFile) => {
            let prev = this.getters['doc/getRoomDocFile'](roomDocFile);
            if(prev){
                _.merge(prev, roomDocFile);
            }else{
                let roomDoc = this.getters['doc/getRoomDoc'](roomDocFile.roomGroupId);
                roomDoc.roomDocFiles.push(roomDocFile);
            }
        }
        if(Array.isArray(roomDocFile)) {
            roomDocFile.forEach(addDocFile)
        } else {
            addDocFile(roomDocFile)
        }
    },
    removeRoomDocFile: function(state, data){
        let {roomGroupId, docId} = data;
        let roomDoc = this.getters['doc/getRoomDoc'](roomGroupId);
        if(!roomDoc) return;

        let idx = roomDoc.roomDocFiles.findIndex(roomDocFile => roomDocFile.docId == docId);
        if(idx < 0){
            return;
        }
        roomDoc.roomDocFiles.splice(idx, 1);

        if(roomDoc.docId == docId) {
            roomDoc.docId = null;
        }
    },
    addPage: function(state, data){
        let {roomDocFile, docFilePage} = data;

        let currRoomDocFile = this.getters['doc/getRoomDocFile'](roomDocFile);
        if(currRoomDocFile){
            // TODO pages merge 문제로 아래 중복체크 로직 필요. 검토할 것.
            let pages = currRoomDocFile.pages;
            _.merge(currRoomDocFile, roomDocFile);
            currRoomDocFile.pages = pages;
            roomDocFile = currRoomDocFile;
        }

        if(!roomDocFile.pages){
            roomDocFile.pages = [];
        }

        let exPageIndex = roomDocFile.pages.findIndex(df => {
            return df.docPageId === docFilePage.docPageId
        });
        if(exPageIndex > -1){
            const exPage = roomDocFile.pages[exPageIndex];
            roomDocFile.pages.splice(exPageIndex, 1, docFilePage);
        }else{
            roomDocFile.pages.push(docFilePage);
        }

        roomDocFile.pages.sort((a,b) => a.docPageSeq - b.docPageSeq);
    },
    changeRoomDocFilePage: function(state, payload){
        let {roomGroupId, docId, docPageId, docPageSeq} = payload;
        let roomDoc = this.getters['doc/getRoomDoc'](roomGroupId);

        if(!roomDoc){
            console.warn('roomDoc is null :', roomGroupId);
            return;
        }

        let roomDocFile = this.getters['doc/getRoomDocFile']({roomGroupId, docId});
        if(roomDocFile){
            roomDocFile.currDocPageId = docPageId;
            roomDocFile.currDocPageSeq = docPageSeq;
        }

        Object.assign(roomDoc, {...{docId, docPageId}});
    },
    uploadRoomDoc: function(state, uploadObj/*{roomGroupId, filename, file}*/){
        state.uploadRoomDocFiles.push(uploadObj);
    },
    uploadRoomDocGroupAll: function(state, uploadObj) {
        state.uploadRoomDocFileAllGroup = uploadObj
    },
    changeUploadRoomDoc: function(state, changeInfo){
        let obj = state.uploadRoomDocFiles.find(u => u.id === changeInfo.id);
        if(!obj){
            console.warn('upload obj is null', changeInfo);
            return;
        }
        Object.assign(obj, changeInfo);
        let percent = Math.round(obj.loaded * 100 / obj.total);
        if(isNaN(percent)){
            console.warn('calc percent :', obj.loaded, obj.total);
        }else{
            obj.percent = percent;
        }

        if(obj.percent >= 100){
            let idx = state.uploadRoomDocFiles.indexOf(obj);
            if(idx > -1){
                state.uploadRoomDocFiles.splice(idx, 1);
            }
        }
    },
    removeUploadRoomDocFile: function(state, uploadObj) {
        let idx = state.uploadRoomDocFiles.findIndex(u => u.id === uploadObj.id);
        if(idx > -1) {
            state.uploadRoomDocFiles.splice(idx, 1);
        }

    },
    setRoomDocId: function(state, data) {
        const {roomGroupId, docId} = data;
        let roomDoc = this.getters['doc/getRoomDoc'](roomGroupId);
        roomDoc.docId = docId;
    },
    changeSharing: function(state, data) {
        const {roomGroupId} = data;
        let roomGroupList = this.getters['roomGroup/roomGroupList'];
        roomGroupList.forEach(rg => {
            if(!rg.roomDoc) {
                return;
            }
            if(rg.roomGroupId === roomGroupId) {
                rg.roomDoc.isSharing = true;
            } else {
                rg.roomDoc.isSharing = false;
            }
        })

        state.roomGroupId = roomGroupId
    },
    // JMT
    SET_CHOSEN_DOC_FILE: function(state, docFile) {
        state.chosenDocFile = docFile;
    },
    TOGGLE_IS_OPEN_DOC_FILE_LIST: function(state) {
        state.isOpenDocFileList = !state.isOpenDocFileList;
    }
}
